export enum Routes {
  INSIGHTS_BASE = '/insights',
  OLIO_ENGAGEMENT_SCORE = 'olio-engagement-score',
  AVERAGE_LENGTH_OF_STAY = 'average-length-of-stay',
  READMISSION_RATE = 'readmission-rate',
  TOTAL_DISCHARGES = 'total-discharges',
  PRIORITIES_NOTE_RESPONSE = 'priorities',
  ESCALATIONS_RESPONSE = 'escalations',
  ACTIVITIES_PER_PATIENT_PER_WEEK = 'activities-per-patient-per-week',
}

export enum Metrics {
  ACCEPTANCE_RATE = 'acceptance_rate',
  ACCEPTED_TO_DISCHARGE_DAYS_AVERAGE = 'accepted_to_discharge_days:average',
  ACTIVITIES_PER_PATIENT_PER_WEEK = 'activities_per_patient_per_week',
  BUSINESS_RESPONSE_TIME_AVERAGE = 'business_response_time:average',
  CANCEL_RATE = 'cancel_rate',
  CREATED_TO_DISCHARGE_DAYS_AVERAGE = 'created_to_discharge_days:average',
  DAYS_TO_START_CARE_AVERAGE = 'days_to_start_care:average',
  DENIAL_RATE = 'denial_rate',
  ID_COUNT = 'id:count',
  LENGTH_OF_STAY_AVERAGE = 'length_of_stay:average',
  LENGTH_OF_STAY_SUM = 'length_of_stay:sum',
  LOCATION_EPISODE_ID_COUNT = 'location_episode_id:count',
  OLIO_ENGAGEMENT_SCORE = 'olio_engagement_score',
  OWNER_ACTIVITIES_SUM = 'owner_activities:sum',
  PENDING_RATE = 'pending_rate',
  READMISSION_LENGTH_OF_STAY_AVERAGE = 'readmission_length_of_stay:average',
  READMISSION_RATE = 'readmission_rate',
  READMISSIONS_SUM = 'readmissions:sum',
  RESPONSE_TIME_AVERAGE = 'response_time:average',
  RESPONSE_TIME_SECONDS_AVERAGE = 'response_time_seconds:average',
  REVIEW_ID_COUNT = 'review_id:count',
  SAFE_RETURNS_REQUESTED_COUNT = 'safe_returns_requested:count',
  SAFE_RETURN_RESPONSE_TIME_AVERAGE = 'safe_return_response_time:average',
  SERVICE_REFUSALS_COUNT = 'service_refusals:count',
}

export enum Dimensions {
  DATE = 'date',
  DENIAL_REASON = 'denial_reason',
  EPISODE_CLASSIFICATION = 'episode_classification',
  EPISODE_ID = 'episode_id',
  EPISODE_URL = 'episode_url',
  GROUP = 'group',
  GROUP_NAME = 'group_name',
  HEALTH_PLAN_CLASSIFICATION = 'health_plan_classification',
  LENGTH_OF_STAY = 'length_of_stay',
  OWNER_CLIENT = 'owner_client',
  OWNER_GROUP_NAME = 'owner_group_name',
  PATIENT_NAME = 'patient_name',
  PLAN_TYPE_CLASSIFICATION = 'plan_type_classification',
  PREDECESSOR_GROUP = 'predecessor_group',
  PROVIDER_CLIENT = 'provider_client',
  PROVIDER_ID = 'provider_id',
  PROVIDER_NAME = 'provider_name',
  READMISSION_DATE = 'readmission_date',
  REASON = 'reason',
  RECEIVING_CLIENT = 'receiving_client',
  RECEIVING_GROUP = 'receiving_group',
  REFERRAL_STATUS = 'referral_status',
  REFERRAL_URL = 'referral_url',
  RESPONSE_TIME_SECONDS = 'response_time_seconds',
  REVIEW_ID = 'review_id',
  SENDING_GROUP = 'sending_group',
  SERVICE_REFUSAL_REFUSED_BY_TYPE = 'service_refusal_refused_by_type',
  TRANSFERRED_FROM = 'transferred_from',
  TRANSFERRED_FROM_CLIENT = 'transferred_from_client',
}

// Mirrors Review::Referral::DENIAL_REASONS on the API.
export const DENIAL_REASON_DISPLAY_NAMES: Record<string, string> = {
  plan_type: 'Plan type not accepted',
  staffing_shortages: 'Staffing shortages',
  capacity_constraints: 'Capacity constraints',
  patient_acuity_too_high: 'Patient acuity too high',
  medical_necessity_not_met: 'Medical necessity not met',
  patient_location: 'Patient location',
  other: 'Other',
};

export enum Sources {
  ESCALATION_ACKS = 'escalation_acks',
  INSIGHTS_CARE_TRANSITIONS = 'insights_care_transitions',
  INSIGHTS_REFERRALS = 'insights_referrals',
  LOCATION_EPISODE_DAYS = 'location_episode_days',
  LOCATION_EPISODE_DISCHARGES = 'location_episode_discharges',
  REVIEWS = 'reviews',
}

export enum AccessModes {
  MANAGER = 'manager',
}

export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc',
}

export const WITH_ID_SUFFIX = ':with_id';
